import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import { Route, Routes } from 'react-router-dom';
import KuisionerList from '../KuisionerList/KuisionerList';
import AddKuisioner from '../AddKuisioner/AddKuisioner';
import './Dashboard.css';

const Dashboard = ({ isOpen, toggleSidebar, handleLogout }) => {
  return (
    <div className="dashboard">
      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} handleLogout={handleLogout} />
      <div className={`main-content ${isOpen ? 'expanded' : ''}`}>
        <Header />
        <div className="content">
          <Routes>
            <Route path="/Dashboard" element={<KuisionerList />} />
            <Route path="/AddKuisioner" element={<AddKuisioner />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
